<template>
  <router-view/>
</template>

<style>
#app {
  font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  width: 100%;
  min-height: 100vh;
}

body {
  margin: 0;
  background-color: white;
  height: 100vh;
}

.home {
  height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.flex {
  display: flex;
  justify-content: space-between;
}

.content {
  width: 90%;
  margin-left: 5%;
  height: 100%;
  overflow: scroll;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.content-home {
  width: 90%;
  margin-left: 5%;
  height: 100%;
  overflow: scroll;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

#nav {
  padding: 30px;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
}

h3 {
  text-align: left;
  font: normal normal bold 18px/18px Helvetica Neue;
  letter-spacing: 0px;
  color: #404040;
  margin: 15px 0;
}

.small {
  font-size: 13px !important; /* PARCE QUE MONSENEGO EST INSUPPPPPPPPPPPP */
}

.big-reco {
  text-align: left;
  font: normal normal bold 22px/20px Helvetica Neue;
  letter-spacing: 0px;
  color: #404040;
}

.reco {
  text-align: left;
  text-decoration: underline;
  font: normal normal bold 16px/21px Helvetica Neue;
  letter-spacing: 0px;
  color: #E12029;
}

.small-reco {
  font-size: 8px;
  font-style: italic;
}

a {
  color: #e12029;
  text-decoration: none;
}

a:visited {
  color: #E12029;
}

a.dark {
  color: #404040;
}

a.dark:visited {
  color: #404040;
}

p {
  font-size: 14px;
  margin: 12px 0;
}

.small-reco a:visited {
  color: grey;
}

.picto-link {
  margin-left: 8px;
  height: 10px;
}

p {
  text-align: left;
  font: normal normal medium 17px/19px Helvetica Neue;
  letter-spacing: 0px;
  color: #404040;
  margin: 5px 0;
}

img.arbre {
  margin-top: 10px;
  width: 100%;
}

.preambule {
  padding: 10px;
  width: 110px;
  text-align: center;
  border-radius: 0 20px 20px 20px;
  background-color: rgba(32, 83, 131, 0.8);
  color: white;
}

.sommaire {
  padding: 10px;
  width: 110px;
  text-align: center;
  border-radius: 20px 0 20px 20px;
  background-color: rgba(32, 83, 131, 0.8);
  color: white;
}

.center {
  text-align: center;
}

.underline {
  text-decoration: underline;
}

.line-through {
  text-decoration: line-through;
}

.italic {
  font-style: italic;
}

.font-light {
  font-size: 12px;
}

.justify-content {
  text-align: justify;
}

/* RESPONSE */

.resp-text {
  margin: 20px 0 20px 0;
  padding: 15px;
  border-radius: 8px;
}

.resp-text.orange {
  background: #FFF2F3 0% 0% no-repeat padding-box;
}

.resp-text.fushia {
  background: #FFF2FB 0% 0% no-repeat padding-box;
}

.subtitle {
  font: normal normal bold 13px/16px Helvetica Neue;
  letter-spacing: 1.09px;
  color: #707070;
  text-transform: uppercase;
}

.toggle-info {
  box-shadow: 0px 2px 5px #00000029;
  border-radius: 8px;
  padding: 3px 15px;
  margin: 10px 0;
}

.info {
  box-shadow: 0px 2px 5px #00000029;
  border-radius: 8px;
  padding: 10px 15px;
  margin: 20px 0;
}

.toggle-fushia {
  background: #FFFFFF 0% 0% no-repeat padding-box;
  box-shadow: 0px 2px 5px #FFBCE9;
  border-radius: 8px;
  padding: 10px 15px;
  margin: 5px 0;
}

.toggle-blue {
  background: #FFFFFF 0% 0% no-repeat padding-box;
  box-shadow: 0px 2px 5px #ADE8F9;
  border-radius: 8px;
  padding: 10px 15px;
  margin: 5px 0;
}

.info-content {
  text-align: left;
  font: normal normal medium 13px/14px Helvetica Neue;
  letter-spacing: 0px;
  color: #707070;
  padding: 0 20px;
}

.small-info-content {
  text-align: left;
  font: normal normal medium 13px/14px Helvetica Neue;
  letter-spacing: 0px;
  color: #707070;
  padding: 0 10px;
  font-size: 12px;
  font-style: italic;
}

ul.f-npf {
  padding-inline-start: 20px;
}

.f-npf {
  list-style-type: decimal;
  text-align: left;
  font: normal normal medium 13px/14px Helvetica Neue;
  letter-spacing: 0px;
  color: #707070;
}

.tiret {
  list-style-type: none;
  text-align: left;
  letter-spacing: 0px;
  color: #707070;
  padding-left: 10px;
}

.tiret li {
  font-size: 14px;
}

.tiret li:before {
  content: '- ';
}

.toggle-title {
  display: flex;
  justify-content: space-between;
  text-align: left;
  font: normal normal bold 15px/15px Helvetica Neue;
  letter-spacing: 0px;
  color: #404040;
  padding: 10px 0 5px 0;
}

.toggled {
  display: none;
}

.toggled.shown {
  display: block;
}

/* END RESPONSE */

/* COLORS */

.nav-block {
  display: flex;
  flex-direction: row;
  flex-flow: wrap;
}

.nav-item {
  margin-right: 4px;
}

.nav-blue {
  color: #27BDF2;
}

.nav-orange p{
  color: #E54F28;
}

.nav-orange p, .nav-green p, .nav-fushia p, .nav-blue p {
  line-height: initial;
}

.nav-green p {
  color: #3BD48E;
}

.nav-fushia p {
  color: #BF0278;
}

.blue, .nav-blue p {
  color: #27BDF2;
}

.age.blue {
  background-color: #27BDF2;
  box-shadow: 0px 2px 5px #ADE8F9;

}

.dark-blue {
  color: #205383;
}

.orange {
  color: #E54F28;
}

.age.orange {
  box-shadow: 0px 2px 5px #FFD9CF;
  background-color: #E54F28;
}

.dark-orange {
  color: #E12029;
}

.fushia {
  color: #C00379;
}

.age.fushia {
  box-shadow: 0px 2px 5px #FFBCE9;
  background-color: #C00379;
}

.green {
  color: #3BD48E;
}

.age.green {
  box-shadow: 0px 2px 5px #ADFED8;
  background-color: #3BD48E;
}

.grey {
  color: #C0C7D2;
}

.gray-lined {
  text-align: left;
  text-decoration: line-through;
  font: normal normal medium 13px/14px Helvetica Neue;
  letter-spacing: 0px;
  color: #C0C7D2;
}

a.red {
  color: red;
}

.bg-green {
  background-color: #EFF6DA;
}

.light-green {
  color: #A8C264;
}

.bg-gray {
  background-color: #ecfbfd;
}

.bg-pink {
  background-color: #FFE9F8;
}

/* END COLORS */

/* CSS ALL BUTTONS */

.age-button-container {
  display: flex;
  flex-direction: column;
}

.row-button-container {
  display: flex;
  flex-direction: row;
  justify-content: space-around;
}

.age-button {
  font: normal normal bold 25px/16px Helvetica Neue;
}

.list-button, .row-button {
  font: normal normal 500 18px/18px Helvetica Neue;
}

.margin-top {
  margin-top: 50px;
}

.large-button {
  width: 100%;
  margin: 10px 0;
  height: 50px;
  text-align: center;
  letter-spacing: 0px;
}

.medium-button {
  width: 100%;
  margin: 5px 0;
  height: 40px;
  text-align: center;
  letter-spacing: 0px;
  font-size: 16px;
}

.return-button {
  width: 90%;
  margin-left: 5%;
  height: 40px;
  text-align: center;
  letter-spacing: 0px;
  font-size: 14px;
  margin-bottom: 3px;
  margin-top: 3px;
}

.medium-tall-button {
  width: 100%;
  margin: 5px 0;
  height: 60px;
  text-align: center;
  letter-spacing: 0px;
  font-size: 16px;
}

.medium-small-button {
  width: 90%;
  margin: 5px 5%;
  min-height: 45px;
  text-align: center;
  font: normal normal medium 14px/16px Helvetica Neue;
  letter-spacing: 0px;
}

.small-button {
  width: 45%;
  margin: 5px 0;
  height: 40px;
  text-align: center;
  letter-spacing: 0px;
}

button {
  border-radius: 8px;
  border: none;
}

button:focus {
  outline: none;
}

button.grey {
  background: #EFF2F7 0% 0% no-repeat padding-box;
  box-shadow: 0px 2px 5px #060D2C29;
  color: #707070;
}

button.green {
  background: #E1FFF1 0% 0% no-repeat padding-box;
  box-shadow: 0px 2px 5px #ADFED8;
  color: #3BD48E;
}

button.green.clicked {
  background: #3BD48E 0% 0% no-repeat padding-box;
  color: white;
}

button.blue {
  background: #DBF7FF 0% 0% no-repeat padding-box;
  box-shadow: 0px 2px 5px #ADE8F9;
  color: #27BDF2;
}

button.blue.clicked {
  background: #27BDF2 0% 0% no-repeat padding-box;
  color: white;
}

button.orange {
  background: #FFF4F1 0% 0% no-repeat padding-box;
  box-shadow: 0px 2px 5px #FFD9CF;
  color: #E54F28;
}

button.orange.clicked {
  background: #E54F28 0% 0% no-repeat padding-box;
  color: white;
}

button.pink {
  background: #FFE9F8 0% 0% no-repeat padding-box;
  box-shadow: 0px 2px 5px #FFBCE9;
  color: #BF0278;
}

button.pink.clicked {
  background: #BF0278 0% 0% no-repeat padding-box;
  color: white;
}

/* END CSS BUTTONS */
</style>
